import "./CompleteRegistrationStepperCard.scss"
import {RaikoLabel, RaikoLabelType} from "@moeindal/base-raiko-panel-components";


export default function CompleteRegistrationStepperCard({index, title, subTitle, selectedStep, step,icon}) {
    return (
        <div className={"stepperCardLayout"} key={index}>
            <div className={"stepperCardContainer"}>
                <div className={"stepperCardIconContainer"}>
                    <div className={icon}/>
                </div>
                <div className={"stepperCardContent"}>
                    <RaikoLabel text={title} raikoLabelType={RaikoLabelType.TITLE}/>
                    <RaikoLabel text={subTitle} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                </div>
            </div>
            <div className={`stageStatusContainer ${selectedStep === step ? "pulse" : selectedStep > step ? "" : ""}`}>
                <div
                    className={`icon_done ${selectedStep === step ? "icon_done_white" : selectedStep > step ? "" : ""}`}/>
            </div>

        </div>
    )
}

export const completeRegistrationStepperCardItems = [
    {
        step: 1,
        title: "معرفی",
        subTitle: "وضعیت ۱",
        icon: "ic_trash_version_one",
    },
    {
        step: 2,
        title: "اطلاعات شخصی",
        subTitle: "وضعیت ۲",
        icon: "ic_trash_version_one",
    },
    {
        step: 3,
        title: "عکس کارت ملی",
        subTitle: "وضعیت ۳",
        icon: "ic_trash_version_one",
    },
    {
        step: 4,
        title: "قوانین و مقررات",
        subTitle: "وضعیت ۴",
        icon: "ic_trash_version_one",
    },
    {
        step: 5,
        title: "ورود به پنل",
        subTitle: "وضعیت ۵",
        icon: "ic_trash_version_one",
    }
]